// Prefixes backend paths with the build-time backend origin (API_BASE_URL,
// a DefinePlugin global). On Django-served shells API_BASE_URL is an empty
// string, so paths stay relative. On static shells (Cloudflare Pages
// previews / dev :3000) it is the absolute backend origin, so full-page
// navigations and direct links reach the backend instead of the static host.
export const backendUrl = (path) => {
  if (!path || /^https?:/i.test(path) || path.startsWith('//')) return path
  return `${API_BASE_URL || ''}${path}`
}
